import styled from 'styled-components'
import {FontWeights} from './Constants'

export const BoldSpan = styled.span`
  font-weight: ${FontWeights.Bold};
`
